import i18n from 'i18next';
export { default as i18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
export { Trans, useTranslation } from 'react-i18next';

// src/index.ts

// src/locales/en.json
var en_default = {
  hello: {
    title: "Welcome to Lifeline",
    subtitle: "Your journey begins here"
  },
  common: {
    appName: "Lifeline",
    loading: "Loading...",
    error: "An error occurred",
    retry: "Retry",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    back: "Back",
    next: "Next",
    done: "Done",
    search: "Search",
    noResults: "No results found",
    seeAll: "See all",
    seeMore: "See more"
  },
  auth: {
    signIn: "Sign In",
    signUp: "Sign Up",
    signOut: "Sign Out",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    continueWith: "Continue with {{provider}}"
  },
  navigation: {
    home: "Home",
    timeline: "Timeline",
    memories: "Memories",
    wrapped: "Wrapped",
    settings: "Settings",
    profile: "Profile"
  },
  memory: {
    title: "Memory",
    memories: "Memories",
    newMemory: "New Memory",
    addMemory: "Add Memory",
    editMemory: "Edit Memory",
    deleteMemory: "Delete Memory",
    deleteConfirm: "Are you sure you want to delete this memory?",
    placeholder: "What's on your mind?",
    addPhoto: "Add Photo",
    addVoice: "Add Voice",
    addVideo: "Add Video",
    addLocation: "Add Location",
    mood: "Mood",
    tags: "Tags",
    addTag: "Add tag",
    pinned: "Pinned",
    private: "Private",
    types: {
      text: "Text",
      photo: "Photo",
      voice: "Voice",
      video: "Video"
    }
  },
  week: {
    week: "Week",
    weekOf: "Week of {{date}}",
    weekNumber: "Week {{number}}",
    weekOfLife: "Week {{number}} of your life",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    noMemories: "No memories this week",
    addFirst: "Add your first memory"
  },
  mood: {
    joyful: "Joyful",
    content: "Content",
    neutral: "Neutral",
    melancholic: "Melancholic",
    anxious: "Anxious",
    excited: "Excited",
    grateful: "Grateful",
    nostalgic: "Nostalgic",
    howFeeling: "How are you feeling?"
  },
  wrapped: {
    title: "Your Year Wrapped",
    subtitle: "A look back at {{year}}",
    generating: "Creating your wrapped...",
    ready: "Your wrapped is ready!",
    view: "View Wrapped",
    share: "Share",
    download: "Download",
    totalMemories: "Total Memories",
    topMood: "Top Mood",
    longestStreak: "Longest Streak",
    days: "days",
    memoriesCreated: "memories created"
  },
  settings: {
    title: "Settings",
    account: "Account",
    preferences: "Preferences",
    language: "Language",
    theme: "Theme",
    themes: {
      light: "Light",
      dark: "Dark",
      system: "System"
    },
    notifications: "Notifications",
    reminders: "Reminders",
    reminderTime: "Reminder Time",
    privacy: "Privacy",
    privacyMode: "Privacy Mode",
    dataExport: "Export Data",
    deleteAccount: "Delete Account",
    about: "About",
    version: "Version"
  },
  errors: {
    generic: "Something went wrong. Please try again.",
    network: "Network error. Please check your connection.",
    unauthorized: "Please sign in to continue.",
    notFound: "The requested resource was not found.",
    validation: "Please check your input and try again.",
    fileTooLarge: "File is too large. Maximum size is {{size}}.",
    unsupportedFormat: "This file format is not supported."
  },
  time: {
    justNow: "Just now",
    minutesAgo: "{{count}} minute ago",
    minutesAgo_other: "{{count}} minutes ago",
    hoursAgo: "{{count}} hour ago",
    hoursAgo_other: "{{count}} hours ago",
    daysAgo: "{{count}} day ago",
    daysAgo_other: "{{count}} days ago",
    weeksAgo: "{{count}} week ago",
    weeksAgo_other: "{{count}} weeks ago"
  }
};

// src/locales/fr.json
var fr_default = {
  common: {
    appName: "Lifeline",
    loading: "Chargement...",
    error: "Une erreur s'est produite",
    retry: "R\xE9essayer",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    done: "Termin\xE9",
    search: "Rechercher",
    noResults: "Aucun r\xE9sultat trouv\xE9",
    seeAll: "Voir tout",
    seeMore: "Voir plus"
  },
  auth: {
    signIn: "Se connecter",
    signUp: "S'inscrire",
    signOut: "Se d\xE9connecter",
    email: "Email",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oubli\xE9 ?",
    noAccount: "Pas encore de compte ?",
    hasAccount: "D\xE9j\xE0 un compte ?",
    continueWith: "Continuer avec {{provider}}"
  },
  navigation: {
    home: "Accueil",
    timeline: "Chronologie",
    memories: "Souvenirs",
    wrapped: "Wrapped",
    settings: "Param\xE8tres",
    profile: "Profil"
  },
  memory: {
    title: "Souvenir",
    memories: "Souvenirs",
    newMemory: "Nouveau souvenir",
    addMemory: "Ajouter un souvenir",
    editMemory: "Modifier le souvenir",
    deleteMemory: "Supprimer le souvenir",
    deleteConfirm: "\xCAtes-vous s\xFBr de vouloir supprimer ce souvenir ?",
    placeholder: "Qu'avez-vous en t\xEAte ?",
    addPhoto: "Ajouter une photo",
    addVoice: "Ajouter un audio",
    addVideo: "Ajouter une vid\xE9o",
    addLocation: "Ajouter un lieu",
    mood: "Humeur",
    tags: "Tags",
    addTag: "Ajouter un tag",
    pinned: "\xC9pingl\xE9",
    private: "Priv\xE9",
    types: {
      text: "Texte",
      photo: "Photo",
      voice: "Audio",
      video: "Vid\xE9o"
    }
  },
  week: {
    week: "Semaine",
    weekOf: "Semaine du {{date}}",
    weekNumber: "Semaine {{number}}",
    weekOfLife: "Semaine {{number}} de votre vie",
    thisWeek: "Cette semaine",
    lastWeek: "La semaine derni\xE8re",
    noMemories: "Pas de souvenirs cette semaine",
    addFirst: "Ajoutez votre premier souvenir"
  },
  mood: {
    joyful: "Joyeux",
    content: "Satisfait",
    neutral: "Neutre",
    melancholic: "M\xE9lancolique",
    anxious: "Anxieux",
    excited: "Excit\xE9",
    grateful: "Reconnaissant",
    nostalgic: "Nostalgique",
    howFeeling: "Comment vous sentez-vous ?"
  },
  wrapped: {
    title: "Votre ann\xE9e en r\xE9sum\xE9",
    subtitle: "Un regard sur {{year}}",
    generating: "Cr\xE9ation de votre r\xE9sum\xE9...",
    ready: "Votre r\xE9sum\xE9 est pr\xEAt !",
    view: "Voir le r\xE9sum\xE9",
    share: "Partager",
    download: "T\xE9l\xE9charger",
    totalMemories: "Total des souvenirs",
    topMood: "Humeur principale",
    longestStreak: "Plus longue s\xE9rie",
    days: "jours",
    memoriesCreated: "souvenirs cr\xE9\xE9s"
  },
  settings: {
    title: "Param\xE8tres",
    account: "Compte",
    preferences: "Pr\xE9f\xE9rences",
    language: "Langue",
    theme: "Th\xE8me",
    themes: {
      light: "Clair",
      dark: "Sombre",
      system: "Syst\xE8me"
    },
    notifications: "Notifications",
    reminders: "Rappels",
    reminderTime: "Heure du rappel",
    privacy: "Confidentialit\xE9",
    privacyMode: "Mode confidentialit\xE9",
    dataExport: "Exporter les donn\xE9es",
    deleteAccount: "Supprimer le compte",
    about: "\xC0 propos",
    version: "Version"
  },
  errors: {
    generic: "Une erreur s'est produite. Veuillez r\xE9essayer.",
    network: "Erreur r\xE9seau. V\xE9rifiez votre connexion.",
    unauthorized: "Veuillez vous connecter pour continuer.",
    notFound: "La ressource demand\xE9e n'a pas \xE9t\xE9 trouv\xE9e.",
    validation: "Veuillez v\xE9rifier votre saisie et r\xE9essayer.",
    fileTooLarge: "Le fichier est trop volumineux. Taille max : {{size}}.",
    unsupportedFormat: "Ce format de fichier n'est pas pris en charge."
  },
  time: {
    justNow: "\xC0 l'instant",
    minutesAgo: "Il y a {{count}} minute",
    minutesAgo_other: "Il y a {{count}} minutes",
    hoursAgo: "Il y a {{count}} heure",
    hoursAgo_other: "Il y a {{count}} heures",
    daysAgo: "Il y a {{count}} jour",
    daysAgo_other: "Il y a {{count}} jours",
    weeksAgo: "Il y a {{count}} semaine",
    weeksAgo_other: "Il y a {{count}} semaines"
  }
};

// src/locales/es.json
var es_default = {
  common: {
    appName: "Lifeline",
    loading: "Cargando...",
    error: "Se produjo un error",
    retry: "Reintentar",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    close: "Cerrar",
    back: "Atr\xE1s",
    next: "Siguiente",
    done: "Listo",
    search: "Buscar",
    noResults: "No se encontraron resultados",
    seeAll: "Ver todo",
    seeMore: "Ver m\xE1s"
  },
  auth: {
    signIn: "Iniciar sesi\xF3n",
    signUp: "Registrarse",
    signOut: "Cerrar sesi\xF3n",
    email: "Correo electr\xF3nico",
    password: "Contrase\xF1a",
    forgotPassword: "\xBFOlvidaste tu contrase\xF1a?",
    noAccount: "\xBFNo tienes una cuenta?",
    hasAccount: "\xBFYa tienes una cuenta?",
    continueWith: "Continuar con {{provider}}"
  },
  navigation: {
    home: "Inicio",
    timeline: "L\xEDnea de tiempo",
    memories: "Recuerdos",
    wrapped: "Resumen",
    settings: "Configuraci\xF3n",
    profile: "Perfil"
  },
  memory: {
    title: "Recuerdo",
    memories: "Recuerdos",
    newMemory: "Nuevo recuerdo",
    addMemory: "Agregar recuerdo",
    editMemory: "Editar recuerdo",
    deleteMemory: "Eliminar recuerdo",
    deleteConfirm: "\xBFEst\xE1s seguro de que quieres eliminar este recuerdo?",
    placeholder: "\xBFQu\xE9 tienes en mente?",
    addPhoto: "Agregar foto",
    addVoice: "Agregar audio",
    addVideo: "Agregar video",
    addLocation: "Agregar ubicaci\xF3n",
    mood: "Estado de \xE1nimo",
    tags: "Etiquetas",
    addTag: "Agregar etiqueta",
    pinned: "Fijado",
    private: "Privado",
    types: {
      text: "Texto",
      photo: "Foto",
      voice: "Audio",
      video: "Video"
    }
  },
  week: {
    week: "Semana",
    weekOf: "Semana del {{date}}",
    weekNumber: "Semana {{number}}",
    weekOfLife: "Semana {{number}} de tu vida",
    thisWeek: "Esta semana",
    lastWeek: "La semana pasada",
    noMemories: "No hay recuerdos esta semana",
    addFirst: "Agrega tu primer recuerdo"
  },
  mood: {
    joyful: "Alegre",
    content: "Contento",
    neutral: "Neutral",
    melancholic: "Melanc\xF3lico",
    anxious: "Ansioso",
    excited: "Emocionado",
    grateful: "Agradecido",
    nostalgic: "Nost\xE1lgico",
    howFeeling: "\xBFC\xF3mo te sientes?"
  },
  wrapped: {
    title: "Tu a\xF1o en resumen",
    subtitle: "Una mirada a {{year}}",
    generating: "Creando tu resumen...",
    ready: "\xA1Tu resumen est\xE1 listo!",
    view: "Ver resumen",
    share: "Compartir",
    download: "Descargar",
    totalMemories: "Total de recuerdos",
    topMood: "Estado de \xE1nimo principal",
    longestStreak: "Racha m\xE1s larga",
    days: "d\xEDas",
    memoriesCreated: "recuerdos creados"
  },
  settings: {
    title: "Configuraci\xF3n",
    account: "Cuenta",
    preferences: "Preferencias",
    language: "Idioma",
    theme: "Tema",
    themes: {
      light: "Claro",
      dark: "Oscuro",
      system: "Sistema"
    },
    notifications: "Notificaciones",
    reminders: "Recordatorios",
    reminderTime: "Hora del recordatorio",
    privacy: "Privacidad",
    privacyMode: "Modo de privacidad",
    dataExport: "Exportar datos",
    deleteAccount: "Eliminar cuenta",
    about: "Acerca de",
    version: "Versi\xF3n"
  },
  errors: {
    generic: "Algo sali\xF3 mal. Por favor, int\xE9ntalo de nuevo.",
    network: "Error de red. Verifica tu conexi\xF3n.",
    unauthorized: "Por favor, inicia sesi\xF3n para continuar.",
    notFound: "El recurso solicitado no fue encontrado.",
    validation: "Por favor, verifica tu entrada e int\xE9ntalo de nuevo.",
    fileTooLarge: "El archivo es demasiado grande. Tama\xF1o m\xE1ximo: {{size}}.",
    unsupportedFormat: "Este formato de archivo no es compatible."
  },
  time: {
    justNow: "Ahora mismo",
    minutesAgo: "Hace {{count}} minuto",
    minutesAgo_other: "Hace {{count}} minutos",
    hoursAgo: "Hace {{count}} hora",
    hoursAgo_other: "Hace {{count}} horas",
    daysAgo: "Hace {{count}} d\xEDa",
    daysAgo_other: "Hace {{count}} d\xEDas",
    weeksAgo: "Hace {{count}} semana",
    weeksAgo_other: "Hace {{count}} semanas"
  }
};

// src/locales/de.json
var de_default = {
  common: {
    appName: "Lifeline",
    loading: "Wird geladen...",
    error: "Ein Fehler ist aufgetreten",
    retry: "Erneut versuchen",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "L\xF6schen",
    edit: "Bearbeiten",
    close: "Schlie\xDFen",
    back: "Zur\xFCck",
    next: "Weiter",
    done: "Fertig",
    search: "Suchen",
    noResults: "Keine Ergebnisse gefunden",
    seeAll: "Alle anzeigen",
    seeMore: "Mehr anzeigen"
  },
  auth: {
    signIn: "Anmelden",
    signUp: "Registrieren",
    signOut: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    noAccount: "Noch kein Konto?",
    hasAccount: "Bereits ein Konto?",
    continueWith: "Weiter mit {{provider}}"
  },
  navigation: {
    home: "Startseite",
    timeline: "Zeitachse",
    memories: "Erinnerungen",
    wrapped: "Jahresr\xFCckblick",
    settings: "Einstellungen",
    profile: "Profil"
  },
  memory: {
    title: "Erinnerung",
    memories: "Erinnerungen",
    newMemory: "Neue Erinnerung",
    addMemory: "Erinnerung hinzuf\xFCgen",
    editMemory: "Erinnerung bearbeiten",
    deleteMemory: "Erinnerung l\xF6schen",
    deleteConfirm: "Bist du sicher, dass du diese Erinnerung l\xF6schen m\xF6chtest?",
    placeholder: "Was besch\xE4ftigt dich?",
    addPhoto: "Foto hinzuf\xFCgen",
    addVoice: "Audio hinzuf\xFCgen",
    addVideo: "Video hinzuf\xFCgen",
    addLocation: "Ort hinzuf\xFCgen",
    mood: "Stimmung",
    tags: "Tags",
    addTag: "Tag hinzuf\xFCgen",
    pinned: "Angeheftet",
    private: "Privat",
    types: {
      text: "Text",
      photo: "Foto",
      voice: "Audio",
      video: "Video"
    }
  },
  week: {
    week: "Woche",
    weekOf: "Woche vom {{date}}",
    weekNumber: "Woche {{number}}",
    weekOfLife: "Woche {{number}} deines Lebens",
    thisWeek: "Diese Woche",
    lastWeek: "Letzte Woche",
    noMemories: "Keine Erinnerungen diese Woche",
    addFirst: "F\xFCge deine erste Erinnerung hinzu"
  },
  mood: {
    joyful: "Freudig",
    content: "Zufrieden",
    neutral: "Neutral",
    melancholic: "Melancholisch",
    anxious: "\xC4ngstlich",
    excited: "Aufgeregt",
    grateful: "Dankbar",
    nostalgic: "Nostalgisch",
    howFeeling: "Wie f\xFChlst du dich?"
  },
  wrapped: {
    title: "Dein Jahresr\xFCckblick",
    subtitle: "Ein Blick auf {{year}}",
    generating: "Dein R\xFCckblick wird erstellt...",
    ready: "Dein R\xFCckblick ist fertig!",
    view: "R\xFCckblick anzeigen",
    share: "Teilen",
    download: "Herunterladen",
    totalMemories: "Gesamte Erinnerungen",
    topMood: "H\xE4ufigste Stimmung",
    longestStreak: "L\xE4ngste Serie",
    days: "Tage",
    memoriesCreated: "Erinnerungen erstellt"
  },
  settings: {
    title: "Einstellungen",
    account: "Konto",
    preferences: "Pr\xE4ferenzen",
    language: "Sprache",
    theme: "Design",
    themes: {
      light: "Hell",
      dark: "Dunkel",
      system: "System"
    },
    notifications: "Benachrichtigungen",
    reminders: "Erinnerungen",
    reminderTime: "Erinnerungszeit",
    privacy: "Datenschutz",
    privacyMode: "Datenschutzmodus",
    dataExport: "Daten exportieren",
    deleteAccount: "Konto l\xF6schen",
    about: "\xDCber",
    version: "Version"
  },
  errors: {
    generic: "Etwas ist schief gelaufen. Bitte versuche es erneut.",
    network: "Netzwerkfehler. Bitte \xFCberpr\xFCfe deine Verbindung.",
    unauthorized: "Bitte melde dich an, um fortzufahren.",
    notFound: "Die angeforderte Ressource wurde nicht gefunden.",
    validation: "Bitte \xFCberpr\xFCfe deine Eingabe und versuche es erneut.",
    fileTooLarge: "Die Datei ist zu gro\xDF. Maximale Gr\xF6\xDFe: {{size}}.",
    unsupportedFormat: "Dieses Dateiformat wird nicht unterst\xFCtzt."
  },
  time: {
    justNow: "Gerade eben",
    minutesAgo: "Vor {{count}} Minute",
    minutesAgo_other: "Vor {{count}} Minuten",
    hoursAgo: "Vor {{count}} Stunde",
    hoursAgo_other: "Vor {{count}} Stunden",
    daysAgo: "Vor {{count}} Tag",
    daysAgo_other: "Vor {{count}} Tagen",
    weeksAgo: "Vor {{count}} Woche",
    weeksAgo_other: "Vor {{count}} Wochen"
  }
};
var languages = {
  en: { name: "English", nativeName: "English" },
  fr: { name: "French", nativeName: "Fran\xE7ais" },
  es: { name: "Spanish", nativeName: "Espa\xF1ol" },
  de: { name: "German", nativeName: "Deutsch" }
};
var defaultLanguage = "en";
var resources = {
  en: { translation: en_default },
  fr: { translation: fr_default },
  es: { translation: es_default },
  de: { translation: de_default }
};
async function initI18n() {
  await i18n.use(LanguageDetector).use(initReactI18next).init({
    resources,
    fallbackLng: defaultLanguage,
    supportedLngs: Object.keys(languages),
    interpolation: {
      escapeValue: false
      // React already escapes values
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "lifeline_language",
      caches: ["localStorage"]
    },
    react: {
      useSuspense: true
    }
  });
  return i18n;
}
async function changeLanguage(language) {
  await i18n.changeLanguage(language);
}
function getCurrentLanguage() {
  return i18n.language;
}

export { changeLanguage, defaultLanguage, getCurrentLanguage, initI18n, languages, resources };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map